import type { JSX } from 'cdui-js';
import { For } from 'cdui-js';
import {
  SERVICE_PHONES,
  callPhone,
  type ServicePhone,
} from '../../pages/mobile/utils/common';
import { isInAppWebView } from '../../analytics/appInfo';

export type PhoneLinkProps = {
  /** 不传则使用 SERVICE_PHONES 全量 */
  phones?: ServicePhone[];
  class?: string;
  style?: JSX.CSSProperties;
  /** 是否可点击拨号，默认 true */
  clickable?: boolean;
  /** 号码分隔符，默认 `/` */
  separator?: string;
};

/**
 * 客服电话展示 + 拨号
 * - App：callPhone → WEB_TO_APP_CallPhone
 * - H5/PC：`<a href="tel:">`
 */
export const PhoneLink = (props: PhoneLinkProps) => {
  const list = () => props.phones ?? SERVICE_PHONES;
  const sep = () => props.separator ?? '/';
  const canClick = () => props.clickable !== false;
  const inApp = () => isInAppWebView();

  return (
    <span class={`phone-link ${props.class ?? ''}`.trim()} style={props.style}>
      <For each={list()}>
        {(item, index) => (
          <>
            {index() > 0 ? sep() : null}
            {canClick() ? (
              inApp() ? (
                <span
                  class="link-color"
                  style={{ cursor: 'pointer' }}
                  onclick={() => callPhone(item.dial)}
                >
                  {item.display}
                </span>
              ) : (
                <a href={`tel:${item.dial}`} class="link-color">
                  {item.display}
                </a>
              )
            ) : (
              <span class="link-color">{item.display}</span>
            )}
          </>
        )}
      </For>
    </span>
  );
};
